import * as R from 'ramda';
import React from 'react';

import {translate} from 'iss/strings';
import {LAST_DAY_OF_MONTH} from 'iss/service/EvaluationActivationService';
import styles from 'iss/styles/DateChoosers.styl';
import {Button} from 'iss/widgets/Buttons';
import {translateWeekday} from 'iss/widgets/domainTranslations';
import {Select, selectorFormComponent} from 'iss/widgets/Forms';
import BootstrapFormGroup from 'iss/widgets/bootstrap/FormGroup';

export const WeekDayChooser = selectorFormComponent(function WeekDayChooser({formApi, valuePath, ...props}) {
  const isChosen = (day) => {
    return R.defaultTo([], formApi.getValue(valuePath)).map(value => value.day).includes(day);
  };
  const setValue = (day) => {
    if (isChosen(day)) {
      formApi.setValue(valuePath, formApi.getValue(valuePath).filter(value => value.day !== day));
    } else {
      formApi.setValue(valuePath, [...R.defaultTo([], formApi.getValue(valuePath)), { day: day, month: null }]);
    }
  };
  return <BootstrapFormGroup {...props}>
    <div id={props.id}>
    {R.range(1, 8).map(d =>
        <Button className={styles.weekday+" weekday-"+d} key={d} buttonLook={isChosen(d) ? 'primary' : 'default'} onClick={() => setValue(d)}>{translateWeekday(d)}</Button>
        )}
    </div>
  </BootstrapFormGroup>;
});

export function MonthDayChooser({...props}) {
  const options = R.append(
    {value: LAST_DAY_OF_MONTH, label: translate('evaluationActivator.lastWorkingDayOfMonth')},
    R.map(d => ({value: d, label: d}), R.range(1,32))
  );
  return <Select options={options} {...props} />;
}

export function YearDayChooser({...props}) {
  const monthLengths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const days = R.reduce(R.concat, [], monthLengths.map((days, index) => R.map(d => d+"."+(index+1), R.range(1, days+1))));

  const options = R.map(d => ({value: d, label: d}), days);
  return <Select options={options} {...props} />;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/input/DateChoosers.jsx